import { makeStyles } from '@mui/styles';
import { muiTheme } from '@tassat/payments-themes';

export default makeStyles((theme: typeof muiTheme) => ({
    root: {
        color: '#202020',
        backgroundColor: '#fff'
    },
    hover: {
        '&:hover': {
            color: '#202020',
            backgroundColor: '#F6F6F6'
        }
    },
    selected: {
        color: '#202020',
        backgroundColor: '#F6F6F6'
    },
    favoriteIcon: {
        height: '16px',
        width: '16px'
    },
    optionDivider: {
        width: '95%',
        backgroundColor: theme?.app?.applicationColors.enumColors.greyLighter || '#cfcfcf'
    }
}));